import { Identifier } from "react-admin";

import { ColumnsOf } from "../data";
import { Maybe } from "../utility";

export const locationState = {
  NotDetermined: "notDetermined",
  Restricted: "restricted",
  Denied: "denied",
  AuthorizedAlways: "authorizedAlways",
  AuthorizedWhenInUse: "authorizedWhenInUse",
  Off: "off"
} as const;
export type LocationState = (typeof locationState)[keyof typeof locationState];

export const bluetoothState = {
  Off: "off",
  On: "on",
  Resetting: "resetting",
  Unauthorized: "unauthorized",
  Unknown: "unknown",
  Unsupported: "unsupported"
} as const;
export type BluetoothState = (typeof bluetoothState)[keyof typeof bluetoothState];

export const cameraState = {
  Allowed: "allowed",
  AskEveryTime: "askEveryTime",
  Restricted: "restricted",
  Denied: "denied",
  notDetermined: "notDetermined",
  notApplicable: "notApplicable"
} as const;
export type CameraState = (typeof cameraState)[keyof typeof cameraState];

export const notificationsState = {
  On: "on",
  Off: "off",
  Provisional: "provisional",
  NotDetermined: "notDetermined",
  Limited: "limited",
  notApplicable: "notApplicable"
} as const;
export type NotificationsState = (typeof notificationsState)[keyof typeof notificationsState];

export const onOffState = {
  On: "on",
  Off: "off",
  notApplicable: "notApplicable"
} as const;
export type OnOffState = (typeof onOffState)[keyof typeof onOffState];

export const autoRestore = {
  Enabled: "enabled",
  Disabled: "disabled",
  notApplicable: "notApplicable"
} as const;
export type AutoRestore = (typeof autoRestore)[keyof typeof autoRestore];

export const backgroundRefresh = {
  ...onOffState,
  Restricted: "restricted",
  notApplicable: "notApplicable"
} as const;
export type BackgroundRefresh = (typeof backgroundRefresh)[keyof typeof backgroundRefresh];

export interface SettingsConfig {
  os: "iOS" | "iPadOS" | "Android" | "VisionOS";
  appVersion: string;
  collectedAt: Maybe<string>;
  previousUploadedAt: Maybe<string>;
  bluetoothStatus: {
    state: BluetoothState;
    didEnterCount: number;
    didExitCount: number;
  };
  locationStatus: {
    state: LocationState;
    gpsCount: number;
    gpsSuccessRate?: Maybe<number>;
    preciseLocation: OnOffState;
  };
  appState: "foreground" | "background";
  networks: string[];
  alarmStatus: Maybe<{
    state: AutoRestore;
  }>;
  cameraStatus: CameraState;
  backgroundRefresh: BackgroundRefresh;
  batteryStatus: {
    level: number;
    lowPowerMode: OnOffState;
    powerRestrictions: OnOffState;
  };
  notificationsStatus: {
    state: NotificationsState;
    internalTrackerNotification: Maybe<OnOffState>;
    locatedNotifications: Maybe<OnOffState>;
    gatewaySDKNotifications: Maybe<OnOffState>;
  };
}

export interface Settings {
  id: Identifier;
  user_id: Identifier;
  space_id: Identifier;
  updated_at: string;
  config: Maybe<SettingsConfig>;
  debug_on: boolean;
  finder_on: boolean;
  gateway_name: string;
  gateway_on: boolean;
  location_on: boolean;
  send_gateway_name: boolean;
  tracker_on: boolean;
}

export const SETTINGS_COLUMNS: ColumnsOf<Settings> = ["*"] as const;
